export default __webpack_public_path__ + "static/media/food-logo.ac27f142.PNG";